import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SidebarMenuItem } from 'src/app/components/sidebar-layout/sidebar-layout.component';
import { FeatureFlagTypes } from 'src/app/models/featureFlag/featureFlagsTypes.enum';
import { FeatureFlagsService } from 'src/app/services/infra/featureFlags/feature-flags.service';

enum PolicyTab {
  Account = 'account',
  Integrations = 'integrations',
}

@Component({
  selector: 'app-policies-landing',
  templateUrl: './policies-landing.component.html',
  styleUrls: ['./policies-landing.component.scss'],
})
export class PoliciesLandingComponent implements OnInit {
  public activeItemId: string = PolicyTab.Integrations;
  public menuItems: SidebarMenuItem[] = [
    {
      id: PolicyTab.Integrations,
      label: 'Integration policies',
      icon: 'assets/images/menu-icons/integrations.svg',
      route: '/app/policies/integrations',
    },
    {
      id: PolicyTab.Account,
      label: 'Account policy',
      icon: 'assets/images/menu-icons/governance.svg',
      route: '/app/policies/account',
    },
  ];
  public isAccountPolicyLayoutEnabled: boolean;

  constructor(
    private readonly _router: Router,
    private readonly _featureFlagsService: FeatureFlagsService
  ) {
    this.isAccountPolicyLayoutEnabled = this._featureFlagsService.isFeatureEnabled(
      FeatureFlagTypes.EnableAccountPolicyLayout
    );
  }

  ngOnInit(): void {
    this._updateActiveTab();

    this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this._updateActiveTab();
    });
  }

  private _updateActiveTab(): void {
    const url = this._router.url;
    if (url.includes('/policies/integrations')) {
      this.activeItemId = PolicyTab.Integrations;
    } else {
      this.activeItemId = PolicyTab.Account;
    }
  }

  public onItemSelected(item: SidebarMenuItem): void {
    this.activeItemId = item.id;
    this._router.navigate([item.route]);
  }
}
